import { get } from 'lodash'
import moment, { Moment } from 'moment'
import React from 'react'
import { Button } from 'react-bootstrap'

type TPresetOptionValue = {
  start: Moment
  end: Moment
}

type TPresetOption = {
  label: string
  value: TPresetOptionValue
}

type TPresets = {
  applyPreset: (val: TPresetOptionValue) => void
  isInfinite: boolean
}

const Presets = (props: TPresets): React.ReactElement => {
  const { applyPreset, isInfinite } = props

  const onChange = (preset: TPresetOption): void => {
    applyPreset(preset.value)
  }

  const presets: TPresetOption[] = [
    {
      label: i18n.t(`date_picker_yesterday`, `Gestern`),
      value: {
        start: moment().subtract(1, 'days').startOf('day').add(5, 'hours'),
        end: moment().subtract(1, 'days').endOf('day').add(5, 'hours'),
      },
    },
    {
      label: i18n.t(`date_picker_today`, `Heute`),
      value: {
        start: moment().startOf('day').add(5, 'hours'),
        end: moment().endOf('day').add(5, 'hours'),
      },
    },
    {
      label: i18n.t(`date_picker_tomorrow`, `Morgen`),
      value: {
        start: moment().add(1, 'days').startOf('day').add(5, 'hours'),
        end: moment().add(1, 'days').endOf('day').add(5, 'hours'),
      },
    },
    {
      label: i18n.t(`date_picker_next_7_days`, `Nächste 7 Tage`),
      value: {
        start: moment().startOf('day').add(5, 'hours'),
        end: moment().add(6, 'days').endOf('day').add(5, 'hours'),
      },
    },
    {
      label: i18n.t(`date_picker_user_choice`, `Benutzerdefiniert`),
      value: {
        start: moment().startOf('day').add(5, 'hours'),
        end: moment().endOf('day').add(5, 'hours'),
      },
    },
    {
      label: i18n.t(`date_picker_no_restrictions`, `Unbeschränkt`),
      value: {
        start: moment.unix(0),
        end: moment.unix(0),
      },
    },
  ]

  return (
    <div>
      {presets.map((preset, index) => (
        <Button
          key={index}
          variant={
            moment(get(preset, 'value.start')).isSame(moment.unix(0)) &&
            isInfinite
              ? 'info'
              : 'light'
          }
          block
          onClick={() => onChange(preset)}
          className="text-left"
        >
          {preset.label}
        </Button>
      ))}
    </div>
  )
}

export default Presets
